/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/offcanvas';
import './components/delay-search-queries';
import './components/fancybox';
import './components/footer-menus';
import './components/sticky-header';
import './components/animate-details';
import './components/animations';
import './components/responsive-tables';
import './components/sticky-sidebar';
import './components/vacancy-sticky-bar';
import './components/training-register';
